exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n    --klassapp-300: #f26948;\n    --klassapp-250: #ff6a47;\n    --klassapp-200: #f4876c;\n    --klassapp-100: #f9c3b5;\n    --klassapp-10: #fce7e1;\n    --klassapp-1: #fef9f7;\n    --whitebase: #fff;\n}\n\n@media (max-width: 768px) {\n    html,\n    body {\n        overflow-x: hidden;\n        width: 100%;\n        margin: 0;\n        padding: 0;\n        -webkit-text-size-adjust: 100%;\n    }\n\n    /* Force container to adapt to mobile */\n    .container_1F_5E {\n        width: 100% !important;\n        padding-left: 15px !important;\n        padding-right: 15px !important;\n        margin-left: auto !important;\n        margin-right: auto !important;\n        max-width: 100vw !important;\n    }\n\n    /* Reset general spacing for mobile */\n    .row_1RHqT {\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n    }\n\n    .col-xs-1_emTvS,\n    .col-sm-1_3NW4o,\n    .col-md-1_1hkSc,\n    .col-lg-1_3QJID,\n    .col-xs-2_3Do_O,\n    .col-sm-2_10iEv,\n    .col-md-2_1SdBx,\n    .col-lg-2_2JqHh,\n    .col-xs-3_2N-Tu,\n    .col-sm-3_3S_t6,\n    .col-md-3_3yse4,\n    .col-lg-3_3snNB,\n    .col-xs-4_1OMeb,\n    .col-sm-4_2q842,\n    .col-md-4_2RQwl,\n    .col-lg-4_1vbnC,\n    .col-xs-5_1KR5p,\n    .col-sm-5_21Sxm,\n    .col-md-5_2zoaK,\n    .col-lg-5_2v_RU,\n    .col-xs-6_2FESx,\n    .col-sm-6_1utDy,\n    .col-md-6_OuFiU,\n    .col-lg-6_1TCVH,\n    .col-xs-7_1B-Q9,\n    .col-sm-7_1t2Uj,\n    .col-md-7_1DniU,\n    .col-lg-7_1_7jw,\n    .col-xs-8_1v83m,\n    .col-sm-8_2dCab,\n    .col-md-8_3_0lx,\n    .col-lg-8_2Dgr_,\n    .col-xs-9_2RjHM,\n    .col-sm-9_az0Zd,\n    .col-md-9__nZ52,\n    .col-lg-9_1brS1,\n    .col-xs-10_Ttwa3,\n    .col-sm-10_3ehOz,\n    .col-md-10_2hM_J,\n    .col-lg-10_2bLcH,\n    .col-xs-11_5t_P9,\n    .col-sm-11_1DHpV,\n    .col-md-11_I7ixq,\n    .col-lg-11_1IyFc,\n    .col-xs-12_2sYBB,\n    .col-sm-12_142Ux,\n    .col-md-12_86pt_,\n    .col-lg-12_2SRaZ {\n        padding-right: 5px !important;\n        padding-left: 5px !important;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"container": "container_1F_5E",
	"row": "row_1RHqT",
	"col-xs-1": "col-xs-1_emTvS",
	"col-sm-1": "col-sm-1_3NW4o",
	"col-md-1": "col-md-1_1hkSc",
	"col-lg-1": "col-lg-1_3QJID",
	"col-xs-2": "col-xs-2_3Do_O",
	"col-sm-2": "col-sm-2_10iEv",
	"col-md-2": "col-md-2_1SdBx",
	"col-lg-2": "col-lg-2_2JqHh",
	"col-xs-3": "col-xs-3_2N-Tu",
	"col-sm-3": "col-sm-3_3S_t6",
	"col-md-3": "col-md-3_3yse4",
	"col-lg-3": "col-lg-3_3snNB",
	"col-xs-4": "col-xs-4_1OMeb",
	"col-sm-4": "col-sm-4_2q842",
	"col-md-4": "col-md-4_2RQwl",
	"col-lg-4": "col-lg-4_1vbnC",
	"col-xs-5": "col-xs-5_1KR5p",
	"col-sm-5": "col-sm-5_21Sxm",
	"col-md-5": "col-md-5_2zoaK",
	"col-lg-5": "col-lg-5_2v_RU",
	"col-xs-6": "col-xs-6_2FESx",
	"col-sm-6": "col-sm-6_1utDy",
	"col-md-6": "col-md-6_OuFiU",
	"col-lg-6": "col-lg-6_1TCVH",
	"col-xs-7": "col-xs-7_1B-Q9",
	"col-sm-7": "col-sm-7_1t2Uj",
	"col-md-7": "col-md-7_1DniU",
	"col-lg-7": "col-lg-7_1_7jw",
	"col-xs-8": "col-xs-8_1v83m",
	"col-sm-8": "col-sm-8_2dCab",
	"col-md-8": "col-md-8_3_0lx",
	"col-lg-8": "col-lg-8_2Dgr_",
	"col-xs-9": "col-xs-9_2RjHM",
	"col-sm-9": "col-sm-9_az0Zd",
	"col-md-9": "col-md-9__nZ52",
	"col-lg-9": "col-lg-9_1brS1",
	"col-xs-10": "col-xs-10_Ttwa3",
	"col-sm-10": "col-sm-10_3ehOz",
	"col-md-10": "col-md-10_2hM_J",
	"col-lg-10": "col-lg-10_2bLcH",
	"col-xs-11": "col-xs-11_5t_P9",
	"col-sm-11": "col-sm-11_1DHpV",
	"col-md-11": "col-md-11_I7ixq",
	"col-lg-11": "col-lg-11_1IyFc",
	"col-xs-12": "col-xs-12_2sYBB",
	"col-sm-12": "col-sm-12_142Ux",
	"col-md-12": "col-md-12_86pt_",
	"col-lg-12": "col-lg-12_2SRaZ"
};